/* Zelara 2026 — Contador del carrito lateral (solo tema borrador).
   Empieza la primera vez que se muestra y NO se reinicia: la hora de fin se guarda en
   localStorage (persiste entre visitas del mismo navegador). Al llegar a cero se queda
   fijo en 00:00. No modifica precios ni el carrito. */
(function () {
  if (customElements.get('z-cart-timer')) return;
  var KEY = 'zCartTimerEnd';
  function readEnd() {
    try { return parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) { return 0; }
  }
  function saveEnd(value) {
    try { localStorage.setItem(KEY, String(value)); } catch (e) {}
  }
  customElements.define('z-cart-timer', class extends HTMLElement {
    connectedCallback() {
      var minutes = parseInt(this.dataset.minutes || '5', 10);
      var end = readEnd();
      if (!end) {
        end = Date.now() + minutes * 60000;
        saveEnd(end);
      }
      this._end = end;
      this._time = this.querySelector('.z-cart-timer__time');
      this.hidden = false;
      this._tick();
      if (this._end > Date.now()) {
        var self = this;
        this._interval = setInterval(function () { self._tick(); }, 1000);
      }
    }
    disconnectedCallback() {
      clearInterval(this._interval);
    }
    _tick() {
      var ms = this._end - Date.now();
      if (ms <= 0) {
        clearInterval(this._interval);
        if (this._time) this._time.textContent = '00:00';
        return;
      }
      var s = Math.ceil(ms / 1000);
      var m = Math.floor(s / 60);
      var r = s % 60;
      if (this._time) {
        this._time.textContent = String(m).padStart(2, '0') + ':' + String(r).padStart(2, '0');
      }
    }
  });
})();
